module.exports = __webpack_public_path__ + "static/media/mro_inventory.9d9c6050e844faf18562f2c2e2c919c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mro_inventory.jpg
// module id = 1884
// module chunks = 1